import { Box, Tab, Tabs, useTheme } from "@mui/material";
import { NavLink, useLocation } from "react-router-dom";

/**
 * AccessNavRail — horizontal MUI Tabs sub-nav wired to react-router.
 *
 * Post-Directory-scaffold, this rail carries the security-policy tabs
 * only: SSO (preview shell), Security · CMK (Customer-Managed Keys,
 * shipping), and Support Audit (shipping). Members / Invitations /
 * Roles / Audit moved to the Directory surface; the follow-up commit
 * on this branch wires the Directory routes.
 */

const ACCESS_TABS = [
  { label: "SSO",             to: "/access/sso",           ship: false },
  // SCK-631 — Security → Customer-Managed Keys.
  { label: "Security · CMK",  to: "/access/security/cmk",  ship: true  },
  // SCK-569 — Layer 3 support-audit console. Real and shipping;
  // shown to ACCOUNT_ADMINs of any customer account that has ever
  // received a support-access grant.
  { label: "Support Audit",   to: "/access/support-audit", ship: true  },
  // SCK-549 PR-6 — caller-scoped Support MCP token mint / revoke.
  // Any signed-in user can manage their own tokens; no role gate.
  { label: "Support MCP",     to: "/access/support-mcp",   ship: true  },
];

function PreviewPip() {
  const theme = useTheme();
  const bg =
    theme.palette.mode === "dark"
      ? theme.palette.grey[800]
      : theme.palette.grey[200];
  const fg =
    theme.palette.mode === "dark"
      ? theme.palette.grey[300]
      : theme.palette.grey[700];
  return (
    <Box
      component="span"
      sx={{
        ml: 1,
        px: 0.75,
        py: 0.1,
        borderRadius: 0.5,
        fontSize: 9.5,
        fontWeight: 700,
        letterSpacing: "0.12em",
        textTransform: "uppercase",
        background: bg,
        color: fg,
        lineHeight: 1.4,
      }}
    >
      preview
    </Box>
  );
}

export default function AccessNavRail({ tabs = ACCESS_TABS }) {
  const location = useLocation();

  // Match the most-specific prefix so /access/members/anything still
  // highlights Members.
  const active =
    [...tabs]
      .sort((a, b) => b.to.length - a.to.length)
      .find((t) => location.pathname.startsWith(t.to))?.to || tabs[0]?.to;

  return (
    <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 2 }}>
      <Tabs
        value={active}
        variant="scrollable"
        scrollButtons="auto"
        aria-label="Access sub-navigation"
      >
        {tabs.map((t) => (
          <Tab
            key={t.to}
            value={t.to}
            component={NavLink}
            to={t.to}
            label={
              <span style={{ display: "inline-flex", alignItems: "center" }}>
                {t.label}
                {!t.ship && <PreviewPip />}
              </span>
            }
            sx={{
              textTransform: "none",
              fontWeight: 600,
              letterSpacing: "0.01em",
              minHeight: 44,
              "&.active": { color: "primary.main" },
            }}
          />
        ))}
      </Tabs>
    </Box>
  );
}
